import React, { useEffect, useState, } from 'react';
import { View, Text, ScrollView,  StyleSheet,  Platform, TouchableOpacity, ActivityIndicator } from 'react-native';

import Colors from '../constants/Colors';
import {  Ionicons } from "@expo/vector-icons"
import { useDispatch, useSelector } from 'react-redux';
import {  NativeBaseProvider,  } from 'native-base';
import { getState } from "../store/action/userLogin"









const Register1 = (props) => {
    const [isFetching, setIsFetching] = useState(false);
    const [ALLState, setALLState] = useState([]);
    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    // const isfocuce=useIsFocused()




    const getALLStateHandler = async () => {
        try {
            setIsFetching(true)
            const res = await dispatch(getState(tokens));

            setALLState(res.data.data.states)

            setIsFetching(false);
            // console.log(res.data.data.states);

        } catch (err) {
            console.log(err);
        }
    };








    useEffect(() => {
        getALLStateHandler()
    }, [])












  
    return (


        <NativeBaseProvider>


            <View style={styles.viewtitle}>
                <Text style={{ fontFamily: "MontserratBold", fontSize: 18, position: "absolute" }}>استان خود را انتخاب کنید</Text>
                
            </View>
            <ScrollView style={{ backgroundColor: Colors.background }}>
                <View style={styles.viewContainer}>





                    {isFetching ?
                        <View style={{ width: "100%", height: "100%", alignItems: "center", justifyContent: "center", backgroundColor: Colors.background }} >
                            <ActivityIndicator
                                animating={isFetching} size={30} color={Colors.primary} />

                            <Text style={{ fontFamily: "MontserratBold", fontSize: 25, color: Colors.primary, marginTop: 30 }}>لطفا شکیبا باشید...</Text>
                        </View>
                        :
                        ALLState.map((item, i) => {
                            return (

                                <TouchableOpacity key={i} onPress={() => {
                                    props.navigation.navigate("register2", {
                                        ids: item.id
                                    })
                                }} style={styles.touch}>
                                    <Ionicons name="arrow-back-outline" size={25} color={Colors.primary} style={{ position: "absolute", left: "5%", top: Platform.OS == "web" ? "28%" : "20%" }} />
                                    <Text style={{ fontFamily: "Montserrat", fontSize: 15, color: Colors.black, position: "absolute", right: "5%", top: Platform.OS == "web" ? "28%" : "20%" }}>{item.state}</Text>
                                </TouchableOpacity>

                            )
                        })}




                </View>
            </ScrollView>
        </NativeBaseProvider>


    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        alignItems: "center",
        marginBottom: 15
    },
    viewtitle: {
        width: "100%",
        height: 60,
        alignItems: "center",
        justifyContent: "center",
        marginTop: "5%",
        backgroundColor: Colors.background,


    },
    touch: {
        flexDirection: "row",
        width: "90%",
        height: 50,
        backgroundColor: Colors.background2,
        marginTop: 8,
        borderRadius: 10
    },

})




export default Register1